import React, { useCallback, useState } from 'react';
import styles from './menu.module.scss';
import cx from 'classnames';
import Hint from '../Hint/Hint';
import { AnimationWrapper } from '../AnimationWrapper/AnimationWrapper';

const MenuItem = ({ children, onClick, disabled, onHover = '', simple, messageClassName, className, ...props }) => {
  const [isHover, setIsHover] = useState(false);

  const handleClick = useCallback(
    e => {
      if (!disabled) {
        onClick(e);
      }
    },
    [disabled, onClick]
  );

  const handleMouseOver = () => {
    disabled && onHover && setIsHover(true);
  };

  const handleMouseLeave = () => {
    disabled && onHover && setIsHover(false);
  };

  return (
    <li
      className={cx({ [styles.simpleMenuItem]: simple, [styles.menuItem]: !simple }, className)}
      onClick={handleClick}
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
      {...props}
    >
      <div className={cx({ [styles.disabled]: disabled })}>
        {children}
      </div>
      {onHover && (
        <AnimationWrapper show={isHover} options={{ duration: 100 }}>
          <Hint className={messageClassName} text={onHover} />
        </AnimationWrapper>
      )}
    </li>
  );
};

export default MenuItem;
